module.exports = __webpack_public_path__ + "img/development.cc85dcfe.png";